import type { LucideIcon } from 'lucide-react';
import { Briefcase, Users, Bot, CalendarCheck, Headset, Workflow, Megaphone, Trophy, Settings } from 'lucide-react';
import type { AdminSection } from '../../../config/adminNavCards';

/** One icon per section — used in the collapsed icon rail and section headers. */
export const SECTION_ICONS: Record<AdminSection, LucideIcon> = {
  sales: Briefcase,
  leads: Users,
  cindy: Bot,
  bookings: CalendarCheck,
  callCentre: Headset,
  automation: Workflow,
  marketing: Megaphone,
  team: Trophy,
  system: Settings,
};
